import { styled } from "@mui/material";

const MainColorContainer = styled('div')(({theme}) => ({
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.getContrastText(theme.palette.primary.dark)
}));

export default MainColorContainer;